import ACTIONS from 'constants/actionTypes';
import { createAction } from 'helpers/redux';
import { LayoutConfiguration } from 'reducers/layoutConfiguration';

export const updateLayoutConfiguration = (
  payload: Partial<LayoutConfiguration>
) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.UPDATE_LAYOUT_CONFIGURATION,
        payload,
      })
    );
  };
};
